import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-dheeraj',
  templateUrl: './dheeraj.component.html',
  styleUrls: ['./dheeraj.component.scss']
})
export class DheerajComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getDheeraj();
  }

}
